import React from 'react';
import Checkbox from './Checkbox';
import CheckList from './CheckList';

const Authorizations = (props) => {
    const { locale, data } = props;
    const configGame1 = ['shop', 'players', 'buildings', 'vehicleModels', 'functions'];
    const configGame2 = ['skills', 'ranks', 'status', 'services', 'incidents'];
    const configGame3 = ['bip', 'radio', 'operations', 'alerts', 'planning', 'geographicSystem', 'superAdmin'];

    return (
        <div className='row'>
            <div className='col'>
                {
                    configGame3.map((configType) => (
                        <Checkbox key={configType} locale={locale} configType={configType} data={data} />
                    ))
                }
            </div>
            <div className='col'>
                {
                    configGame1.map((configType) => (
                        <CheckList key={configType} locale={locale} configType={configType} data={data} />
                    ))
                }
            </div>
            <div className="col">
                {
                    configGame2.map((configType) => (
                        <CheckList key={configType} locale={locale} configType={configType} data={data} />
                    ))
                }
            </div>
        </div>
    );
};

export default Authorizations;
